import {
  NO_CHANGES_TO_TAXES_IMAGE_BASE_URL,
  SecondhandTaxesLandingPageSection,
} from '../../constants'

export const getProofSectionContent = (countryCode = 'UK') => {
  const imageUrl = `${NO_CHANGES_TO_TAXES_IMAGE_BASE_URL}/${countryCode}/DAC7-photo-proof-mobile`
  const desktopImageUrl = `${NO_CHANGES_TO_TAXES_IMAGE_BASE_URL}/${countryCode}/DAC7-photo-proof-desktop`

  return {
    componentId: SecondhandTaxesLandingPageSection.Proof,
    testId: 'no-changes-to-taxes--proof-section',
    text: {
      title: 'secondhand_taxes.proof.title',
      subtitle: 'secondhand_taxes.proof.subtitle',
      description: 'secondhand_taxes.proof.description',
    },
    image: {
      src: `${imageUrl}.png`,
      srcSet: `${imageUrl}.png 520w, ${imageUrl}@2x.png 1040w, ${imageUrl}@3x.png 1560w, `,
      srcDesktop: `${desktopImageUrl}.png`,
      srcSetDesktop: `${desktopImageUrl}.png 520w, ${desktopImageUrl}@2x.png 1040w, ${desktopImageUrl}@3x.png 1560w, `,
    },
  }
}
